import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { DialogBody, DialogDescription, DialogHeader, DialogTitle } from '@/components/core/dialog';
import { FormDialogContent } from '@/components/forms/form-dialog';
import { TextareaFormField } from '@/components/forms/textarea-form-field';
import { Result } from '@/shared/helpers/Result';

const schema = z.object({
  reason: z.string().trim().min(1, 'Reason is required'),
});

type Props = {
  onAdd: (reason: string) => Promise<Result>;
};

export function HoldDialogContent({ onAdd }: Props) {
  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: { reason: '' },
  });

  return (
    <FormDialogContent
      form={form}
      submitLabel="Add hold"
      // Must return the Result so the dialog stays open on failure (e.g. a 409
      // duplicate reason) and the operator's typed reason is preserved.
      onSubmit={(data) => onAdd(data.reason)}
    >
      <DialogHeader>
        <DialogTitle>Add hold</DialogTitle>
        <DialogDescription>
          Add a hold to this bill. A bill with any active hold cannot be closed.
        </DialogDescription>
      </DialogHeader>
      <DialogBody>
        <TextareaFormField
          control={form.control}
          name="reason"
          label="Reason"
          placeholder="Reason for placing this bill on hold"
        />
      </DialogBody>
    </FormDialogContent>
  );
}
